import React from "react";
import "./DetailsSection.scss";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";
import dressCode from "./images/dresscode.webp";
import dressCodeEn from "./images/dresscode-en.webp";
import scanMoney from "./images/qr-code.webp";
import butilka from "./images/restaurant.webp";
import kumove from "./images/kumove.webp";
import Transport from "./Transport";

export default function RingsSection({ t }) {
  return (
    <div className="relative overflow-hidden p-block-8 bg-white">
      <div className="container text-center">
        <OnScrollAnimationWrapper
          animation={"animation-slide-fade-in-down"}
          triggerOnce={false}
          classNameInitialState={`opacity-0 text-animation-slide-in`}
        >
          <h2 className="font-heading text-primary letter-spacing-4px">{t.details}</h2>
        </OnScrollAnimationWrapper>
        <div className="flex flex-align-center flex-justify-center gap-1 hearth-separator m-top-0 m-bottom-2"><div className="heart-separator-line bg-third"></div><i className="fa-solid fa-heart text-third text-xs"></i><div className="heart-separator-line bg-third"></div></div>
        <div className="flex flex-direction-column gap-4">
        <div className="col-12 details-card p-2">
          <h5 className="letter-spacing-2px m-bottom-1 font-weight-700 m-top-2">{t.accommodation}</h5>
          <OnScrollAnimationWrapper
            animation={"animation-slide-fade-in-down"}
            triggerOnce={false}
            classNameInitialState={`opacity-0 text-animation-slide-in`}
          >
            <div className="text-italic m-bottom-2 text-primary">{t.accommodationSubtitle}</div>
          </OnScrollAnimationWrapper>
          <img src={butilka} width="100%" height="auto" style={{ maxWidth: "400px" }} />
          <div className=" m-bottom-1 text-justify" style={{ fontSize: "16px" }}>
            {t.accommodationTextLead}<span className="font-weight-700 text-border">{t.accommodationTextBold}</span> <br /><br />
            {t.accommodationTextAfter}</div>
            <div className="hidden-xsm"><Transport t={t} isInner={true} /></div>
        </div>
        <div className="col-12 details-card p-2">
          <h5 className="letter-spacing-2px m-bottom-1 font-weight-700 m-top-2">{t.dressCode}</h5>
          <OnScrollAnimationWrapper
            animation={"animation-slide-fade-in-down"}
            triggerOnce={false}
            classNameInitialState={`opacity-0 text-animation-slide-in`}
          >
            <div className="text-italic m-bottom-2 text-primary">{t.dressCodeSubtitle}</div>
          </OnScrollAnimationWrapper>
          <img src={t.isEnglish ? dressCodeEn : dressCode} width="100%" height="auto" />
          <div className="text-center text-xs m-bottom-1">{t.dressCodeNote}</div>
        </div>
        <div className="col-12 details-card p-2">
          <h5 className="letter-spacing-2px m-bottom-1 font-weight-700 m-top-2">{t.gifts}</h5>
          <OnScrollAnimationWrapper
            animation={"animation-slide-fade-in-down"}
            triggerOnce={false}
            classNameInitialState={`opacity-0 text-animation-slide-in`}
          >
            <div className="text-italic m-bottom-2 text-primary">{t.giftsSubtitle}</div>
          </OnScrollAnimationWrapper>
          <a href="https://revolut.me/nelialeksandrova" target="_blank">
            <img src={scanMoney} width="100%" height="auto" style={{ maxWidth: "200px" }} />
          </a>
          <div className="text-center text-xs m-bottom-1" style={{ marginTop: "-8px"}}>(@angel_georgiev5, @nelialeksandrova)</div>
          <div className="text-center text-xs m-bottom-1">{t.giftsNoteLead}<a href="https://revolut.me/nelialeksandrova" className="text-border"target="_blank">{t.giftsNoteLink}</a>{t.giftsNoteEnd}</div>
        </div>
        <div className="col-12 details-card p-2">
          <h5 className="letter-spacing-2px m-bottom-1 font-weight-700 m-top-2">{t.bestPeople}</h5>
          <OnScrollAnimationWrapper
            animation={"animation-slide-fade-in-down"}
            triggerOnce={false}
            classNameInitialState={`opacity-0 text-animation-slide-in`}
          >
            <div className="text-italic m-bottom-2 text-primary">{t.bestPeopleSubtitle}</div>
          </OnScrollAnimationWrapper>
          <img src={kumove} width="100%" height="auto" style={{ maxWidth: "200px" }} />
        </div>
        </div>
      </div>
    </div>
  );
}
